export default __webpack_public_path__ + "7380fe8b528ecdb0bc96aa1f0319ba47.png";